export const SETTINGS_ROOT_PATH = '/settings';



// WEBPACK FOOTER //
// ./src/components/Settings/constants.js